import CalendarExperienceView from "../../views/CalendarExperienceView";

/**
 * /dashboard/content-calendar. Everyone gets the team calendar; for a Guest (a
 * brand's client) it runs read-only with client-side answers (see
 * guestCalendar.ts). The client-portal view of a month lives on its own page,
 * /dashboard/content-review, opened from the calendar header.
 */
export default function ContentCalendarRoute() {
  return <CalendarExperienceView />;
}
